var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcChatCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 20,
    height: 20,
    rx: 10,
    stroke: "#017C71"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8576 6.68024C16.0979 6.92056 16.0979 7.3102 15.8576 7.55053L9.08839 14.3198C8.84807 14.5601 8.45843 14.5601 8.2181 14.3198L5.14118 11.2428C4.90086 11.0025 4.90086 10.6129 5.14118 10.3726C5.3815 10.1322 5.77114 10.1322 6.01146 10.3726L8.65325 13.0143L14.9873 6.68024C15.2277 6.43992 15.6173 6.43992 15.8576 6.68024Z",
    fill: "#017C71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcChatCheck);
export default __webpack_public_path__ + "static/media/CcChatCheck.03cb106561ade7edfb8b1cf26b592288.svg";
export { ForwardRef as ReactComponent };